import { render, staticRenderFns } from "./hazardFocusInspectionCommonResult.vue?vue&type=template&id=06c79602"
import script from "./hazardFocusInspectionCommonResult.vue?vue&type=script&lang=js"
export * from "./hazardFocusInspectionCommonResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c79602')) {
      api.createRecord('06c79602', component.options)
    } else {
      api.reload('06c79602', component.options)
    }
    module.hot.accept("./hazardFocusInspectionCommonResult.vue?vue&type=template&id=06c79602", function () {
      api.rerender('06c79602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/hazardEquipment/hazardFocusInspectionCommonResult.vue"
export default component.exports